import React from "react";
import { useGridApiContext, GridEditInputCell } from "@mui/x-data-grid";
import { TextField, Autocomplete } from "@mui/material";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
}));
const CustomEditSelect = (props) => {
  const { id, value, field, hasFocus, error, setErrors, optionsType, options } =
    props;

  const [getValue, setValue] = React.useState(value.data);
  const [inputValue, setInputValue] = React.useState("");

  //
  setErrors(error);
  const apiRef = useGridApiContext();
  const ref = React.useRef();
  React.useLayoutEffect(() => {
    if (hasFocus) {
      ref.current.focus();
    }
  }, [hasFocus]);

  const handleValueChange = (event, newInputValue) => {
    const newValue = newInputValue; // The new value entered by the user
    apiRef.current.setEditCellValue({
      id,
      field,
      value: { ...value, data: newValue },
    });
    //apiRef.current.updateRows([{ id: id, value: {...value , data:newValue} }]);
    setValue(newValue);
    setInputValue(newInputValue);
  };

  const GroupOption = React.useMemo(() => {
    return optionsType === "Groups" ? options.map((row) => row.name) : options;
  }, [options, optionsType]);

  return (
    <>
      <StyledTooltip open={!!error} title={error}>
        <Autocomplete
          disableClearable
          options={GroupOption}
          getOptionLabel={(option) => (option ? option : "")}
          isOptionEqualToValue={(option, value) => option === value}
          value={getValue}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
          inputValue={inputValue}
          onInputChange={(event, newInputValue) => {
            handleValueChange(event, newInputValue);
          }}
          fullWidth
          renderInput={(params) => (
            <TextField
              inputRef={ref}
              focused
              sx={{
                backgroundColor: error ? "#ff000014 !important" : "transparent",
                "& .MuiInputBase-root": {
                  "& fieldset": {
                    borderColor: "transparent",
                  },
                  "&:hover fieldset": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "transparent",
                  },
                },
                "& .MuiOutlinedInput": {
                  border: "unset !important",
                },
              }}
              {...params}
            />
          )}
        />
        {/*  <GridEditInputCell ref={ref} {...props} value={value.data} onChange={handleValueChange}/>
         */}
      </StyledTooltip>
    </>
  );
};

export default CustomEditSelect;
